// extracted by mini-css-extract-plugin
module.exports = {"whole":"About_whole__Xlsfl"};